module.exports = __webpack_public_path__ + "static/non-qualified-retirement-plan-mobile.71dbd465.webp";